export const formatNumber = (num: string | number): string => {
  const isNumber = num?.toString().match(/^-?\d+(\.\d+)?$/gi)

  if (num && isNumber && !isNaN(Number(num))) {
    const parsedNum = parseFloat(num?.toString() || '')
    return parsedNum.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 10
    })
  }

  return num?.toString() || ''
}

export const formatDynamicNumber= (num: string | number): string => {
  const isNumber = num?.toString().match(/^-?\d+(\.\d+)?$/gi)

  if (num && isNumber && !isNaN(Number(num))) {
    const parsedNum = parseFloat(num?.toString() || '')
    const decimalCount = (parsedNum.toString().split('.')[1] || '').length;
    return parsedNum.toLocaleString('en-US', {
      minimumFractionDigits: decimalCount > 0 ? 2 : 0,
      maximumFractionDigits: 10
    })
  }

  return num?.toString() || ''
}